export const SUCCESS = 'profile/SUCCESS';
export const FAILED = 'profile/FAILED';
export const LOADING = 'profile/LOADING';
